// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import { StyledTextInput } from "./StyledTextInput-APP_CLIENT.styled";

export interface StyledTextInputProps {
  disabled?: boolean;
  error: string | null;
  focused: boolean;
}

export default StyledTextInput;
